export class PetTreatmentPlanModel {
    tran_sequence: number;
    pet_no: number;
    code_no: number;
    link_no: number;
    link_type: string;
    unit: number;
    unit_cost: number;
    req_date: Date;
    appr_date: Date;
    done_date: Date;
    code_name: string;
    code_category: string;
    category_name: string;
    procedure_desc: string; 
    req_by: string;
    request_date: Date;
    start_date: Date;
    alt_days: number;
    request_generate: boolean;
    request_times: number;
    remain_times: number;
    remarks:string;

    constructor(
        tran_sequence: number,
        pet_no: number,
        code_no: number,
        link_no: number,
        link_type: string,
        unit: number,
        unit_cost: number,
        req_date: Date,
        appr_date: Date,
        done_date: Date,
        code_name: string,
        code_category: string,
        category_name: string,
        procedure_desc: string,
        req_by: string,
        request_date: Date,
        start_date: Date,
        alt_days: number,
        request_generate: boolean,
        request_times: number,
        remain_times: number,
        remarks:string
    ) {
        this.tran_sequence = tran_sequence;
        this.pet_no = pet_no;
        this.code_no = code_no;
        this.link_no = link_no;
        this.link_type = link_type;
        this.unit = unit;
        this.unit_cost = unit_cost;
        this.req_date = req_date;
        this.appr_date = appr_date;
        this.done_date = done_date;
        this.code_name = code_name;
        this.code_category = code_category;
        this.category_name = category_name;
        this.procedure_desc = procedure_desc;
        this.req_by = req_by;
        this.request_date = request_date;
        this.start_date = start_date;
        this.alt_days = alt_days;
        this.request_generate = request_generate;
        this.request_times = request_times;
        this.remain_times = remain_times;
        this.remarks = remarks;
    }
}